/**
 * Calculates order totals including Taxable Value, GST, and Grand Total.
 * Replicates logic from invoiceGenerator.js to ensure consistency.
 * 
 * @param {Array} items - Array of order items { priceAfterTax, gstRate, qty }
 * @param {Number} shippingCost - Shipping charge
 * @returns {Object} { subtotal, totalTaxable, totalTax, totalAmount }
 */
export const calculateOrderTotals = (items = [], shippingCost = 0) => {
    let totalTaxable = 0;
    let totalTax = 0;
    let subtotal = 0; // Sum of item totals (inclusive of tax)

    items.forEach(item => {
        const qty = Number(item.qty) || 0;
        const priceInclusive = Number(item.priceAfterTax || item.price || 0);
        const gstRate = Number(item.gstRate || item.taxRate || 0);

        // Calculate Exclusive Price (Back-calculate from Inclusive)
        // Price = Taxable * (1 + GST/100)
        // Taxable = Price / (1 + GST/100)
        const priceExclusive = priceInclusive / (1 + gstRate / 100);

        const itemTaxable = priceExclusive * qty;
        const itemTotal = priceInclusive * qty;
        const itemTax = itemTotal - itemTaxable;

        totalTaxable += itemTaxable;
        totalTax += itemTax;
        subtotal += itemTotal;
    });

    const totalAmount = subtotal + Number(shippingCost);

    return {
        subtotal: Number(subtotal.toFixed(2)),
        totalTaxable: Number(totalTaxable.toFixed(2)),
        totalTax: Number(totalTax.toFixed(2)),
        shipping: Number(shippingCost),
        total: Number(totalAmount.toFixed(2))
    };
};
